export interface Objective {
  id: number;
  title: string;
  description: string;
  status: ObjectiveStatus;
  createdById: string;
  clientId: string;
  createdAt: string;
  updatedAt: string;
  startingValue: number;
  currentScore: number;
  targetValue: number;
  progressUpdates?: ObjectiveProgress[];
  type: ObjectiveType;
  unit: ObjectiveUnit
}

export interface ObjectiveProgress {
  id: number;
  objectiveId: number;
  score: number;
  updatedById: string;
  updatedAt: string;
  note: string;
}

export interface ClientProgressSummary {
  totalObjectives: number;
  completedObjectives: number;
  averageProgress: number;
}

// Enum pour le statut de l'objectif
export enum ObjectiveStatus {
  EnCours = 0,
  Termine = 1,
  Abandonne = 2,
}

export enum ObjectiveType {
  Progressif = 0,
  Subjectif = 1,
  Degressif = 2,
  Duree = 3,
  Frequence = 4,
}

export enum ObjectiveUnit {
  KG = 0,
  CM = 1,
  KM = 2,
  MIN = 3,
  REP = 4,
  SESSIONS = 5,
  BPM = 6,
  KCAL = 7,
  SUBJECTIF = 8,
}